import {
  States,
  SERVING_HOLDING_TEMP_UNIT_DEFAULT,
  SERVING_HOLDING_TIME_UNIT_DEFAULT
} from './constants';

function getPpsiStatus(ppsi) {
  if (!ppsi) {
    return '';
  }
  const {
    inProgressPpsiEnrichmentData: inProgressData,
    publishedPpsiEnrichmentData: publishedData
  } = ppsi;
  if (publishedData && publishedData.status === States.PUBLISHED) {
    return States.PUBLISHED;
  }
  if (inProgressData) {
    if (inProgressData.status === States.DRAFT) {
      return States.DRAFT;
    }
    if (inProgressData.status === States.REJECTED) {
      return States.REJECTED;
    }
    if (inProgressData.status === States.REVIEW) {
      return States.REVIEW;
    }
    if (inProgressData.status === States.SCHEDULED) {
      return States.SCHEDULED;
    }
  }
  if (publishedData && publishedData.status === States.UNPUBLISHED) {
    return States.UNPUBLISHED;
  }

  return '';
}

function getPpsiDefaultData(languages, dish, storeLists, salesAreas) {
  if (!dish) {
    throw new Error(
      'Unable to get PPSI default values as no Dish is available'
    );
  }  
 
  const defaultData = {
    dish,
    ingredientEntryIds: dish.ingredientEntryIds,
    info: {},
    servingHoldingTempUnit: SERVING_HOLDING_TEMP_UNIT_DEFAULT,
    servingHoldingTimeUnit: SERVING_HOLDING_TIME_UNIT_DEFAULT,
    showHoldingInfoOnDishLevel: false,
    storeCode: storeLists,
    salesPointCode: salesAreas,
    ingredientEntryList:dish.ingredientEntryList
  };
  const { presentationName } = dish;
  languages.forEach(language => {
    defaultData.info[language] = {
      presentationName: presentationName[language]
    };
  });

  return defaultData;
}

function getPpsiVariantData(
  languages,
  dish,
  storeLists,
  salesAreas,
  mainImage,
  parentPpsiEnrichmentDataId,
  servingHoldingTemp,
  servingHoldingTempUnit,
  servingHoldingTime,
  servingHoldingTimeUnit,
  servingInstructions,
  showHoldingInfoOnDishLevel,
  ppiDetails,
  info,
  updateNotificationList,
  dishLabel,
  ingredientEntryList
) {
  if (!dish) {
    throw new Error(
      'Unable to get PPSI default values as no Dish is available'
    );
  }
  const defaultData = {
    dish,
    mainImage,
    ingredientEntryIds: dish.ingredientEntryIds,
    parentPpsiEnrichmentDataId,
    info: {},
    ppiDetails,
    servingInstructions,
    servingHoldingTempUnit,
    servingHoldingTimeUnit,
    showHoldingInfoOnDishLevel,
    servingHoldingTemp,
    servingHoldingTime,
    storeCode: storeLists,
    salesPointCode: salesAreas,
    updateNotificationList,
    dishLabel,
    ingredientEntryList
  };
  // const { presentationName } = dish;
  languages.forEach(language => {
    defaultData.info[language] = {
      presentationName: info[language].presentationName,
      additionalInformation: info[language].additionalInformation
    };
  });

  return defaultData;
}

export { getPpsiStatus, getPpsiDefaultData, getPpsiVariantData };
